module.exports = __webpack_public_path__ + "static/img/part1.f033867.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/index/eng/part1.png
// module id = BKP7
// module chunks = 0